import * as Animate from "react-reveal";
import PodcastImageEji from "../../../assets/images/png/podcast/enyinnaya-ijoma-v2Podcast.png";
import PodcastImageEyitayo from "../../../assets/images/png/podcast/eyitayo-ogunmola-v2Podcast.png";
import PodcastImageOlamide from "../../../assets/images/png/podcast/olamide-abdul-v2Podcast.png";
import PodcastImageOnyinye from "../../../assets/images/png/podcast/onyinye-mystash-v2Podcast.png";

const EPISODE_URL = "https://open.spotify.com/episode/0z7MleCXvfcq3WnN6MwhaV";

const GUESTS = [
  { src: PodcastImageEyitayo, alt: "Eyitayo Ogunmola, Utiva podcast guest" },
  { src: PodcastImageOlamide, alt: "Olamide Abdul, Utiva podcast guest" },
  { src: PodcastImageEji, alt: "Enyinnaya Ijoma, Utiva podcast guest" },
  { src: PodcastImageOnyinye, alt: "Onyinye, myStash, Utiva podcast guest" },
];

const WAVEFORM_HEIGHTS = [
  9,
  18,
  12,
  24,
  15,
  21,
  10,
  19,
  13,
  26,
  16,
  11,
  23,
  14,
  9,
  20,
  12,
  17,
  10,
  22,
];

const Waveform = ({ spread = false }) => (
  <div
    className={`podcast-waveform${spread ? " podcast-waveform--spread" : ""}`}
    aria-hidden="true"
  >
    {WAVEFORM_HEIGHTS.map((h, i) => (
      <span
        key={i}
        className="podcast-waveform-bar rounded-full bg-secondary inline-block shrink-0"
        style={{ height: `${h}px`, opacity: 0.45 + (h / 26) * 0.55 }}
      />
    ))}
  </div>
);

const PodcastHeaderSection = () => {
  return (
    <section
      className="podcast-grid-hero mx-auto gap-[34px] lg:gap-[58px] items-center px-[18px] sm:px-[26px] pt-[54px] sm:pt-[58px] lg:pt-[74px] pb-8 lg:pb-12"
      style={{ maxWidth: "1280px" }}
      aria-labelledby="podcast-page-heading"
    >
      <Animate.Fade bottom>
        <div>
          <p className="flex items-center gap-3 text-primary tracking-[0.1em] text-[14px] font-extrabold leading-[1.45] mb-5">
            <span className="w-[34px] h-[3px] bg-secondary inline-block shrink-0" />
            THE UTIVA PODCAST
          </p>
          <h1
            id="podcast-page-heading"
            className="tracking-[-0.045em] leading-[1.05] max-w-[620px]  font-extrabold"
            style={{ fontSize: "clamp(42px, 5vw, 64px)" }}
          >
            <span className="text-primary block">Meet the people</span>
            <span className="text-[#0c0c1f] block">behind the ideas.</span>
          </h1>
          <div className="max-w-[300px] sm:max-w-[360px] h-[6px] bg-secondary rounded-full mb-[26px]" />
          <p className="text-[#555b6e] max-w-[520px] text-[17px] sm:text-[19px] leading-[1.78] m-0">
            Useful conversations with founders, operators and technology
            professionals&mdash;told by the people who lived them.
          </p>

          <div className="flex flex-wrap items-center gap-4 mt-[34px]">
            <a
              href="#podcast"
              className="border border-primary bg-primary text-white rounded-xl inline-flex items-center justify-center gap-[11px] text-[15px] font-bold px-[26px] hover:bg-[#03045f] hover:-translate-y-0.5 transition-all w-full sm:w-auto"
              style={{
                minHeight: "54px",
                boxShadow: "0 14px 34px rgba(5,7,148,0.17)",
              }}
            >
              Explore episodes <span aria-hidden="true">↓</span>
            </a>
            <a
              href={EPISODE_URL}
              target="_blank"
              rel="noreferrer"
              className="border border-primary text-primary bg-white rounded-xl inline-flex items-center justify-center gap-[11px] text-[15px] font-bold px-[26px] hover:-translate-y-0.5 transition-all w-full sm:w-auto"
              style={{ minHeight: "54px" }}
            >
              Listen on Spotify <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </Animate.Fade>

      <Animate.Fade bottom>
        <div
          className="podcast-player-card relative overflow-hidden"
          style={{
            background:
              "linear-gradient(155deg, #0b0ea3 0%, #050794 45%, #000269 100%)",
            boxShadow: "0 30px 70px rgba(20,27,68,0.28)",
          }}
        >
          <div className="flex items-center justify-between mb-8 sm:mb-10">
            <span className="text-secondary tracking-[0.14em] text-[13px] sm:text-[14px] font-extrabold">
              NOW PLAYING
            </span>
            <Waveform />
          </div>

          <div className="flex items-center mb-8 sm:mb-10">
            {GUESTS.map((guest, i) => (
              <img
                key={guest.alt}
                src={guest.src}
                alt={guest.alt}
                className="avatar-face rounded-full object-cover border-white shrink-0"
                style={{ marginLeft: i === 0 ? 0 : "-18px" }}
              />
            ))}
          </div>

          <h2
            className="text-white font-extrabold tracking-[-0.03em] leading-[1.15] mb-3"
            style={{ fontSize: "clamp(28px, 3vw, 38px)" }}
          >
            Real people. Useful stories.
          </h2>
          <p className="text-[#d7dbff] text-[16px] sm:text-[17px] mb-8 sm:mb-10">
            Four conversations ready to play.
          </p>

          <Waveform spread />
        </div>
      </Animate.Fade>
    </section>
  );
};

export default PodcastHeaderSection;
